module.exports = __webpack_public_path__ + "media/packs/src/assets/images/filter-200148c21d18477949b64a4c36ebeeda.svg";